import {Component, Input} from '@angular/core';
import {Announcement} from '../../models/announcement';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';
import {UserService} from '../../generated/api/user.service';
import {AnnouncementService} from '../../services/announcement.service';
import {UtilsService} from '../../appSharedModule/services/utils.service';
import {BaseClientComponent} from '../base-client.component';
import {HttpClient} from '@angular/common/http';
import * as _ from 'lodash';
import {environment} from '../../../environments/environment';
import {UserLogged} from '../../models/userLogged';

@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.scss']
})
export class InformationComponent extends BaseClientComponent {

  @Input()
  currentUser: UserLogged;
  supportEmailAddress = 'support@mckay-brothers.com';
  urgentEmailAddress = 'urgent@mckay-brothers.com';
  onBoardingAddress = 'onboarding@mckay-brothers.com';
  jiraServiceDeskPortalUrl = 'https://mckay-brothers.atlassian.net/servicedesk/customer/portal';
  urgentInfoMessage = 'For urgent production support (e.g. McKay systems appear to be down during or approaching market hours, non-weather-related issues)';
  isCommercialOptIn: boolean;
  commercialOptIn: boolean;
  companyUniqid: string;
  numberOfActiveUsers: number;
  numberOfTotalUsers: number;
  companyCreatedAt: Date;
  companyUpdatedAt: Date;
  announcements: Announcement[] = [];
  loadingAnnouncements = true;

  constructor(public authenticationService: AuthenticationService,
              private userService: UserService,
              protected utilsService: UtilsService,
              private announcementService: AnnouncementService,
              protected http: HttpClient) {
    super();
  }

  @Input()
  set selected(selected: boolean) {
    if (selected) {
      if (this.currentUser) {
        this.commercialOptIn = this.currentUser.commercialOptIn;
        this.companyUniqid = this.currentUser.company.uniqid;
        this.numberOfActiveUsers = this.currentUser.company.activeUsers;
        this.numberOfTotalUsers = this.currentUser.company.totalUsers;
        this.companyCreatedAt = this.currentUser.company.createdAt;
        this.companyUpdatedAt = this.currentUser.company.updatedAt;
        this.getBrandEmails();
        const response$ = this.authenticationService.waitForAuthenticationThenLaunch(() => {
          this.getLatestAnnouncements();
        });
        this.subscriptions.push(response$);
      }
    }
  }

  activateCommercialOptIn() {
    this.userService.putUserItem(this.currentUser.id + '', {'commercialOptIn': true}).subscribe(
      () => {
        this.isCommercialOptIn = true;
        this.currentUser.commercialOptIn = true;
        this.commercialOptIn = this.currentUser.commercialOptIn;
      }
    );
  }

  private getLatestAnnouncements() {
    if (this.authenticationService.getUserCurrent().permissions.isMckayUser) {
      this.announcementService.getLatestAnnouncements().subscribe({
        next: announcements => {
          this.announcements = announcements['member'];
          this.announcements = _.orderBy(this.announcements, ['sentAt'], ['desc']);
          this.loadingAnnouncements = false;
        },
        error: () => {
          this.loadingAnnouncements = false;
        }
      });
    } else {
      this.announcementService.getLatestAnnouncementsClient().subscribe({
        next: announcements => {
          this.announcements = announcements['member'];
          this.announcements = _.orderBy(this.announcements, ['sentAt'], ['desc']);
          this.utilsService.unlockUi();
          this.loadingAnnouncements = false;
        },
        error: () => {
          this.loadingAnnouncements = false;
        }
      });
    }
  }

  private getBrandEmails() {
    if (window.location.origin === environment.mckayDomaine) {
      this.supportEmailAddress = 'support@mckay-brothers.com';
      this.urgentEmailAddress = 'urgent@mckay-brothers.com';
      this.onBoardingAddress = 'onboarding@mckay-brothers.com';
    } else if (window.location.origin === environment.quincyDomaine) {
      this.urgentInfoMessage = 'For urgent production support (e.g. McKay/Quincy systems appear to be down during or approaching market hours, non-weather-related issues)';
      this.supportEmailAddress = 'support@quincy-data.com';
      this.urgentEmailAddress = 'urgent@quincy-data.com';
      this.onBoardingAddress = 'onboarding@quincy-data.com';
    }
  }
}
